// Generated with tools/create-component.js
import React from "react";
import { Button, Carousel, CarouselTypes, CmsContent, Container, Image, Link } from "components";
import { SliderInformativeQueryFragment } from "codegen";
import "./SliderInformative.scss";
import classNames from "classnames";
import { decode } from "html-entities";

interface SliderInformativeProps {
  data: SliderInformativeQueryFragment;
}

export const SliderInformative: React.FC<SliderInformativeProps> = ({ data }): JSX.Element => {
  const swiperSettings: CarouselTypes = {
    id: "informative-carousel",
    slidesPerView: 1,
    loop: false,
    spaceBetween: "9%",
    grabCursor: false,
    navigation: true,
    breakpoints: {
      768: {
        slidesPerView: 1.7,
        centeredSlides: true,
      },
      2500: {
        slidesPerView: 2.4,
        centeredSlides: true,
      },
    },
  };

  const containerWidth = "layout--full";

  return (
    <section
      className={classNames({
        "slider-informative": true,
        section: true,
        [`${containerWidth}`]: containerWidth,
      })}
    >
      <div>
        {data.slider && (
          <Carousel swiperSettings={swiperSettings}>
            {data.slider.map((slide, index) => {
              return (
                <div key={`slider-content-block__${index}`} className="slide-content">
                  <div className="slide-content-inner">
                    <p className="slider-title typography--h4">{data.title}</p>
                    {slide.title && <p className="slide-title typography--h2">{slide.title}</p>}
                    <div>
                      <CmsContent content={slide.content} />
                    </div>
                    {slide.cta && (
                      <Link
                        to={slide.cta.url}
                        target={slide.cta.target}
                        title={decode(slide.cta.title)}
                        className="slide-cta"
                      >
                        <Button variant="outline" colorScheme="secondaryalt" rightIcon="ArrowLink">
                          {decode(slide.cta.title)}
                        </Button>
                      </Link>
                    )}
                  </div>
                  {slide.image && <div className="slide-image">{<Image src={slide.image} />}</div>}
                </div>
              );
            })}
          </Carousel>
        )}
      </div>
    </section>
  );
};
